// extracted by mini-css-extract-plugin
export var circle = "_3g-2";
export var icon = "_3g-a";
export var iconHighlight = "_3g-0";
export var lg = "_3g-8";
export var md = "_3g-7";
export var outline = "_3g-4";
export var sm = "_3g-6";
export var square = "_3g-1";
export var xl = "_3g-9";
export var xs = "_3g-5";
export var xxs = "_3g-3";